import React, { useState, useEffect } from 'react';
import api from '../api';

function Admin() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState("Contact");
    const [text, setText] = useState("");

    function tab(t, setActiveTab) {
        setActiveTab(t);
    }

    function Contact() {
        const handleDelete = async (id) => {
            try {
                await api.delete(`/api/admin/delete-contact/${id}`);
                setData(
                    {
                        ...data,
                        contacts: data.contacts.filter((item) => item.id !== id)
                    }
                )
            } catch (error) {
                alert("error");
            }
        }

        return (<div>
            <div className="list-group">
                {data.contacts.map((item, index) => (
                    <div key={index} href="#" className="list-group-item list-group-item " aria-current="true">
                        <div className="d-flex w-100 justify-content-between">
                            <h5 className="mb-1">{item.name}</h5>
                            <p>{item.email}</p>
                            <p>{item.subject}</p>
                            <p>{item.user}</p>
                            <svg onClick={() => { handleDelete(item.id) }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                            </svg>
                            <small>{item.date}</small>
                        </div>
                        <p className="mb-1">{item.message}</p>
                        {/* <small>And some small print.</small> */}
                    </div>
                ))}
            </div>
        </div>
        )
    }

    function PromoCode() {
        const [name, Setname] = useState("");
        const [expDate, SetexpDate] = useState("2030-01-01");
        const [amount, Setamount] = useState(1);
        const [percent, Setpercent] = useState("");
        const [copied, setCopied] = useState(false);

        const handleDelete = async (id) => {
            try {
                await api.delete(`/api/admin/delete-promo/${id}`);
                setData(
                    {
                        ...data,
                        promo_codes: data.promo_codes.filter((item) => item.id !== id)

                    }
                )
            } catch (error) {
            }
        }

        const handleSubmit = async () => {
            try {
                const res = await api.post("/api/admin/create-promo/", { name, expDate, amount, percent });
                if (res.status === 200) {
                    setData(
                        {
                            ...data,
                            promo_codes: [...data.promo_codes, res.data]
                        }
                    )
                    Setname("");
                    SetexpDate("2030-01-01");
                    Setamount(1);
                    Setpercent("");
                }
            }
            catch (error) {
                alert("error");
            }
        }

        const updatetext = (code) => {
            const updatedText = text.replace(/\*/g, code);
            return updatedText
        };

        return (<div>
            <div className="container m-4 ">
                <textarea
                    value={text}
                    placeholder="şablon"
                    onChange={(e) => setText(e.target.value)}
                    rows={5}
                    style={{ width: "100%" }}
                />

                <button onClick={() => { setText("") }} >Delete</button>

                <div className="d-flex flex-column flex-md-row p-4 gap-4 py-md-5 align-items-center justify-content-center">
                    <div className="list-group d-grid gap-2 border-0 col-md-12  ">
                        <div href="#" className="list-group-item  d-flex gap-3 py-3 rounded-3" aria-current="true" >

                            <div className="d-flex gap-2 w-100 justify-content-between">
                                <div>
                                    <div className="input-group mb-3">
                                        <input
                                            type="text"
                                            className="form-control w-100"
                                            size="100"
                                            onChange={(event) => Setname(event.target.value)}
                                            placeholder="Name"
                                            value={name}
                                        />
                                        <input
                                            type="date"
                                            className="form-control "
                                            size="100"
                                            onChange={(event) => SetexpDate(event.target.value)}
                                            placeholder="Exp date"
                                            value={expDate}
                                        />
                                        <input
                                            type="number"
                                            size="100"
                                            className="form-control "
                                            onChange={(event) => Setamount(event.target.value)}
                                            placeholder="Amount"
                                            value={amount}
                                        />
                                        {/* <input
                                            type="number"
                                            className="form-control "
                                            size="100"
                                            max={100}
                                            min={0}
                                            onChange={(event) => Setpercent(event.target.value)}
                                            placeholder="Percent"
                                            value={percent}
                                        /> */}
                                        <button onClick={handleSubmit} className="btn btn-outline-secondary" type="button" id="button-addon2">Add</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="list-group">
                {data.promo_codes.slice().reverse().map((item, index) => (
                    <div key={index} href="#" className="list-group-item list-group-item " aria-current="true">
                        <div className="d-flex w-100 justify-content-between">

                            <h5
                                className="mb-1"
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    navigator.clipboard.writeText(updatetext(item.code))
                                        .then(() => {
                                            setCopied(true);
                                            setTimeout(() => setCopied(false), 2000);
                                        });
                                }}
                            >
                                {item.code}
                                {copied && <span style={{ marginLeft: 10, color: 'green' }}>Kopyalandı!</span>}
                            </h5>


                            <p>{item.email}</p>
                            <svg onClick={() => { handleDelete(item.id) }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                            </svg>
                            <small>{item.exprial_date}</small>
                        </div>
                        <p className="mb-1">{item.percent}</p>
                        <p className="mb-1">{item.amount}</p>
                        {/* <small>And some small print.</small> */}
                    </div>
                ))}

            </div>
        </div>
        )
    }

    function ManuelSocial() {
        const [followers, Setfollowers] = useState(0);
        const handleDecline = async (id) => {
            try {
                await api.delete(`/api/admin/manuel_social_media/`, {
                    data: { id }
                });
                setData({
                    ...data,
                    manule_socials: data.manule_socials.filter((item) => item.id !== id)
                });
            } catch (error) {
                alert("error");
            }
        };

        const handleAccept = async (id) => {
            try {
                await api.post(`/api/admin/manuel_social_media/`, { id, followers });
                Setfollowers(0);
                setData(
                    {
                        ...data,
                        manule_socials: data.manule_socials.filter((item) => item.id !== id)
                    }
                )
            } catch (error) {
                alert("error");
            }
        }

        const link = (username, socialmedia) => {
            if (socialmedia === "X") {
                return `https://x.com/${username}`;
            }
            if (socialmedia === "Instagram") {
                return `https://www.instagram.com/${username}`;
            }
            if (socialmedia === "Tiktok") {
                return `https://www.tiktok.com/@${username}`;
            }
            if (socialmedia === "Youtube") {
                return `https://www.youtube.com/@${username}`;
            }
            if (socialmedia === "Facebook") {
                return `https://www.facebook.com/@${username}`;
            }
        }

        return (<div>
            <div className="list-group">
                {data.manule_socials.map((item, index) => (<div key={index}>

                    <div href="#" className="list-group-item list-group-item mb-5" aria-current="true">
                        <div className="container text-center">
                            <div className="row">
                                <div className="col">
                                    link
                                </div>
                                <div className="col">
                                    <a
                                        href={item.social_media === "Facebook" ? item.username : link(item.username, item.social_media)}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {item.social_media === "Facebook" ? item.username : link(item.username, item.social_media)}
                                    </a>
                                </div>

                            </div>
                            <hr />
                            <div className="row">
                                <div className="col">
                                    username
                                </div>
                                <div className="col">
                                    {item.name}
                                </div>
                            </div>
                            <hr />
                            <div className="row">
                                <div className="col">
                                    social media
                                </div>
                                <div className="col">
                                    {item.social_media}
                                </div>
                            </div>
                            <hr />
                            <div className="row">
                                <div className="col">
                                    name
                                </div>
                                <div className="col">
                                    {item.username}
                                </div>
                            </div>
                            <hr />
                            <div className="row">
                                <div className="col">
                                    followers
                                </div>
                                <div className="col">
                                    <input className="form-control rounded-3" onChange={(e) => { Setfollowers(e.target.value) }} type="number" />
                                </div>
                            </div>
                            <hr />
                            <div className="row">
                                <div className="col">
                                    <button onClick={() => { handleAccept(item.id) }} type="button" className="btn btn-success">Accept</button>
                                </div>
                                <div className="col">
                                    <button onClick={() => { handleDecline(item.id) }} type="button" className="btn btn-danger">Decline</button>
                                </div>
                            </div>
                        </div>
                        <p className="mb-1">{item.message}</p>
                        {/* <small>And some small print.</small> */}
                    </div>
                    <p></p>
                    <p></p>
                </div>
                ))}
            </div>
        </div>)
    }

    function Socials() {
        const [followers, Setfollowers] = useState(0);

        const handleUpdate = async (id) => {
            try {
                await api.put(`/api/admin/update_socials/`, { id, followers });
                Setfollowers(0);
                setData(
                    {
                        ...data,
                        socials: data.socials.filter((item) => item.id !== id)
                    }
                )
            } catch (error) {
                alert("error");
            }
        }

        const handleDelete = async (id) => {
            try {
                await api.post(`/api/admin/update_socials/`, { id });
                setData(
                    {
                        ...data,
                        socials: data.socials.filter((item) => item.id !== id)
                    }
                )
            } catch (error) {
                alert("error");
            }
        }

        return (<>
            <div className="list-group">
                {data.socials.map((item, index) => (

                    <div key={index} className="list-group-item list-group-item mb-5" aria-current="true">
                        <div className="container text-center">

                            <div className="row">
                                <div className="col">
                                    username
                                </div>
                                <div className="col">
                                    {item.username}
                                </div>
                            </div>
                            <hr />
                            <div className="row">
                                <div className="col">
                                    update date
                                </div>
                                <div className="col">
                                    {item.update_date}
                                </div>
                            </div>
                            <hr />
                            <div className="row">
                                <div className="col">
                                    link
                                </div>
                                <div className="col">
                                    <a href={item.link} target="_blank" rel="noopener noreferrer">{item.link}</a>
                                </div>
                            </div>
                            <hr />
                            <div className="row">
                                <div className="col">
                                    followers
                                </div>
                                <div className="col">
                                    {item.followers}
                                </div>
                            </div>
                            <hr />
                            <div className="row">
                                <div className="col">
                                    update followers
                                </div>
                                <div className="col">
                                    <input onChange={(e) => { Setfollowers(e.target.value) }} className="form-control rounded-3" type="number" />
                                </div>
                            </div>
                            <hr />
                            <div className="row">
                                <div className="col">
                                    <button onClick={() => { handleUpdate(item.id) }} type="button" className="btn btn-success">Update</button>

                                </div>
                                <div className="col">
                                    <button onClick={() => { handleDelete(item.id) }} type="button" className="btn btn-danger">Delete</button>

                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </>)
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await api.get("/api/admin/data/");

                setData(response.data);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    function PhoneSideBar({ activeTab, setActiveTab }) {
        const [isSidebarOpen, setSidebarOpen] = useState(false);

        const toggleSidebar = () => {
            setSidebarOpen(!isSidebarOpen);
        };

        return (
            <div  >
                <button style={{ border: "none", position: "fixed", zIndex: "1000", background: "none", }} onClick={toggleSidebar}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fillRule="currentColor" className="bi bi-justify" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M2 12.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                    </svg>
                </button>
                <div className={` sidebar ${isSidebarOpen ? 'open' : ''}`}>

                    <ul className="nav nav-pills flex-column list-group">
                        <li className="nav-item">
                            <button onClick={() => { tab("Contact", setActiveTab); toggleSidebar(); }} className={activeTab === "Contact" ? "nav-link aactive" : "nav-link"} aria-current="page">
                                Contact
                            </button>
                        </li>
                        <li>
                            <button onClick={() => { tab("PromoCode", setActiveTab); toggleSidebar(); }} className={activeTab === "PromoCode" ? "nav-link aactive" : "nav-link"}>
                                PromoCode
                            </button>
                        </li>
                        <li>
                            <button onClick={() => { tab("ManuelSocial", setActiveTab); toggleSidebar(); }} className={activeTab === "ManuelSocial" ? "nav-link aactive" : "nav-link"}>
                                ManuelSocial
                            </button>
                        </li>
                        <li>
                            <button onClick={() => { tab("Socials", setActiveTab); toggleSidebar(); }} className={activeTab === "Socials" ? "nav-link aactive" : "nav-link"}>
                                Socials
                            </button>
                        </li>

                    </ul>

                </div>
                <div className={`content ${isSidebarOpen ? 'shift' : ''}`} >
                    {activeTab === 'Contact' && <Contact />}
                    {activeTab === 'PromoCode' && <PromoCode />}
                    {activeTab === 'ManuelSocial' && <ManuelSocial />}
                    {activeTab === 'Socials' && <Socials />}
                </div>
            </div>
        );
    }


    if (loading) {
        return (
            <div>
                <h1>Loading...</h1>
            </div>
        );
    }
    if (!data) {
        return (
            <div>
                <h1>You are unauthorized</h1>
            </div>
        );
    }

    return (
        <>

            <PhoneSideBar activeTab={activeTab} setActiveTab={setActiveTab} />

            {/* <div>
                <main className="d-flex flex-nowrap" style={{ overflowY: "hidden" }} >
                    <div className="d-flex flex-column flex-shrink-0 p-3 bg-body-tertiary " style={{ width: "170px", position: "fixed", height: "95vh" }}>
                        <ul className="nav nav-pills flex-column mb-auto ">
                            <li>
                                <button onClick={() => tab("Contact", setActiveTab)} style={{ width: "135px" }} className={activeTab === "Contact" ? "nav-link active" : "nav-link"}>Contact</button>
                            </li>
                            <li>
                                <button onClick={() => tab("PromoCode", setActiveTab)} style={{ width: "135px" }} className={activeTab === "PromoCode" ? "nav-link active" : "nav-link"}>PromoCode</button>
                            </li>
                            <li>
                                <button onClick={() => tab("ManuelSocial", setActiveTab)} style={{ width: "135px" }} className={activeTab === "ManuelSocial" ? "nav-link active" : "nav-link"}>ManuelSocial</button>
                            </li>
                            <li>
                                <button onClick={() => tab("Socials", setActiveTab)} style={{ width: "135px" }} className={activeTab === "Socials" ? "nav-link active" : "nav-link"}>Socials</button>
                            </li>
                        </ul>

                    </div>
                    <div className="container-fluid" style={{ overflowX: "hidden" }} >
                        <div className="row justify-content-center">
                            <div className="col-md-12">
                                <div className="d-flex justify-content-center">
                                    <div style={{ width: "100%", maxWidth: "1200px", marginLeft: "160px" }}>
                                        {activeTab === 'Contact' && <Contact />}
                                        {activeTab === 'PromoCode' && <PromoCode />}
                                        {activeTab === 'ManuelSocial' && <ManuelSocial />}
                                        {activeTab === 'Socials' && <Socials />}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div> */}
        </>
    );
}
export default Admin;

